import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f4c9793c&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=f4c9793c&prod&scoped=true&lang=css&external"
import style1 from "./login.vue?vue&type=style&index=1&id=f4c9793c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9793c",
  null
  
)

export default component.exports